import * as React from 'react'
import { ServiceLocationCard } from './ServiceLocationCard'
import { ServiceLocationListProps } from './typings'
import { useGetRelatedLocationsOnMount } from '@user/store/entityLocations'

import CircularProgress from '@mui/material/CircularProgress'

export const ServiceLocationList: React.FC<ServiceLocationListProps> = (
  props,
) => {
  const {
    billTo: { id },
    styles,
  } = props

  const { loading, items } = useGetRelatedLocationsOnMount(id)

  return loading ? (
    <CircularProgress color="primary" sx={styles.loadingSpinner} />
  ) : (
    <>
      {items.map((svcLoc) => (
        <ServiceLocationCard
          {...props}
          key={svcLoc.id}
          serviceLocation={svcLoc}
        />
      ))}
    </>
  )
}
ServiceLocationList.displayName = 'ServiceLocationList'
